import { render, staticRenderFns } from "./ServicesDisplay.vue?vue&type=template&id=61b765fd"
import script from "./ServicesDisplay.vue?vue&type=script&lang=js"
export * from "./ServicesDisplay.vue?vue&type=script&lang=js"
import style0 from "./ServicesDisplay.vue?vue&type=style&index=0&id=61b765fd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports